import { get, post } from '@api/request';

export const fetchPreference = async (
  { userService },
  authenticationToken,
  { userId },
) => {
  const url = `${userService}/trueprodigy/user/${userId}/preference/process`; //need to update
  const { body } = await get(authenticationToken, url);
  return body;
};

export const persistPreference = async (
  { userService },
  authenticationToken,
  { userId, data },
) => {
  const url = `${userService}/trueprodigy/user/${userId}/preference/process`; //need to update
  const { body } = await post(authenticationToken, url, data);
  return body;
};

export const fetchRecalcErrorsbyYear = async (
  { userService },
  authenticationToken,
  { year, page, pageSize },
) => {
  const url = `${userService}/recalc/recalcerrorsforyear/${year}?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
};
